
//处理搜索结果
export function ResultFormat (resultList) {

    let result = [];

    let poiListByFloor = [],
        poiListIndex = 0;

    // filter
    for (let index in resultList) {
        let poiInfo = resultList[index];
        if(poiInfo.FLOOR_ID) {
            if (poiListByFloor[poiInfo.FLOOR_ID]) {
                poiListByFloor[poiInfo.FLOOR_ID].list.push(poiInfo)
            } else {
                poiListByFloor[poiInfo.FLOOR_ID] = {
                    floorID: poiInfo.FLOOR_ID,
                    floorName: poiInfo.FLOOR_NAME,
                    floorNumber: poiInfo.FLOOR_NUMBER,
                    list: [poiInfo]
                };
                poiListIndex++
            }
        }
    }

    // filter
    for (let id in poiListByFloor) {
        result.push(poiListByFloor[id]);
    }

    result.sort((a, b) => {
        return a.floorNumber - b.floorNumber;
    });

    return result;

}
